var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevenueicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00004 5.45455C6.00004 4.65122 6.61565 4 7.37504 4H15.625C16.3844 4 17 4.65122 17 5.45455C17 6.25787 16.3844 6.90909 15.625 6.90909H13.5142C13.7604 7.35928 13.9512 7.84761 14.0767 8.36364H15.625C16.3844 8.36364 17 9.01486 17 9.81818C17 10.6215 16.3844 11.2727 15.625 11.2727H14.0767C13.606 13.2076 12.2181 14.7529 10.4325 15.3591L12.4723 17.5169C13.0093 18.085 13.0093 19.0059 12.4723 19.574C11.9353 20.142 11.0647 20.142 10.5278 19.574L6.40277 15.2103C6.00952 14.7943 5.89188 14.1687 6.10471 13.6252C6.31753 13.0817 6.8189 12.7273 7.37504 12.7273H8.75003C9.76791 12.7273 10.6566 12.1423 11.1321 11.2727H7.37504C6.61565 11.2727 6.00004 10.6215 6.00004 9.81818C6.00004 9.01486 6.61565 8.36364 7.37504 8.36364H11.1321C10.6566 7.49411 9.76791 6.90909 8.75003 6.90909H7.37504C6.61565 6.90909 6.00004 6.25787 6.00004 5.45455Z",
    fill: "#0A0046",
    stroke: "#DFE2E9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueicon);
export default __webpack_public_path__ + "static/media/Revenue icon.a77524f551cf059820ef0af94f54e5d4.svg";
export { ForwardRef as ReactComponent };